import { sampleClips } from "./sampleData.js";
export function getBirthdaySample(staticAssetBaseUrls, themeId = "birthday-cake", themeVersion) {
    return {
        version: 1,
        occasionId: "birthday",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: ["30 years YOUNG! 🎉", "Happy Birthday!", "We love you!"],
        },
        outroGreeting: {
            enabled: true,
            messages: [
                "Happy Birthday! ❤️",
                "We hope that your day is most splendid, that you got all the presents that you want, and that this next year is the best year of your life!",
            ],
        },
        faceCollageEnabled: true,
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "happy-birthday-funk",
                name: "Happy Birthday Funk",
                duration: 168.202449,
                urls: [
                    "https://s3.us-east-2.amazonaws.com/music.vidhug.com/Happy_Birthday_Funk.mp3",
                ],
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        userInput: {
            name: "Sarah",
            age: "30",
        },
        clips: sampleClips,
    };
}
